/* eslint-disable */
import React from 'react'
import { motion } from 'framer-motion'
import WelcomeCalendar from '../../../../assets/img/welcome-calendar.png'

import styles from './styles.module.css'

const Calendar = () => (
  <motion.div
    className={styles.calendar}
    initial={{
      opacity: 0,
      y: -100,
    }}
    animate={{
      opacity: 1,
      y: 0,
    }}
  >
    <img src={WelcomeCalendar} alt="Calendar" />
  </motion.div>
)

export default Calendar
